import { createRoute, redirect, type AnyRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { UsersPage } from "./pages/UsersPage";

/** Search params on /system/users. The selected user (drawer) lives in the
 *  URL so a user detail view is shareable and survives reloads. */
export interface UsersSearch {
  /** Selected user id — opens the drawer. */
  u?: string;
  /** Drawer expanded to full page. */
  expanded?: boolean;
}

function validateUsersSearch(raw: Record<string, unknown>): UsersSearch {
  const out: UsersSearch = {};
  if (typeof raw.u === "string" && raw.u) out.u = raw.u;
  if (raw.expanded === true || raw.expanded === "true") out.expanded = true;
  return out;
}

export const usersModule: FeatureModule = {
  key: "users",
  nav: {
    label: "Users",
    icon: Users,
    to: "/system/users",
    requires: "core.users.read",
    order: 10,
    group: "System",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/system/users",
      component: guarded("core.users.read", UsersPage),
      validateSearch: validateUsersSearch,
    }),
    // Legacy path from the old combined Admin section.
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/admin/users",
      beforeLoad: () => {
        throw redirect({ to: "/system/users" });
      },
    }),
  ] as unknown as AnyRoute[],
};
